module.exports = __webpack_public_path__ + "static/media/clapping-hands.cc997947.gif";